import { BulkResizeImage } from "../../types";

export const getFlipOperation = (image: BulkResizeImage, value: "horizontal" | "vertical") =>
    ({
        name: "flip",
        value: { value, rotation: image.rotate.rotation },
    }) as const;
